import {createSlice} from "@reduxjs/toolkit";
import {addNavbar, fetchActiveNavbar} from "./globalComponentsThunks";

export const activeNavbarSlice = createSlice({
    name: 'activeNavbar',
    initialState: {
        activeNavbar: null,
    },
    loading: null,
    error: null,
    reducers: {
        updateActiveNavbar: (state, action) => {
            state.activeNavbar = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchActiveNavbar.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchActiveNavbar.fulfilled, (state, action) => {
                state.loading = false;
                state.activeNavbar = action.payload; // Set the active appbar
            })
            .addCase(fetchActiveNavbar.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message; // Capture any error that occurs
            })
            .addCase(addNavbar.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addNavbar.fulfilled, (state, action) => {
                state.loading = false;
                state.activeNavbar = action.payload; // Update the active appbar with the newly added one
            })
            .addCase(addNavbar.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message; // Capture any error that occurs
            });
    }
})

export const {updateActiveNavbar} = activeNavbarSlice.actions;
export default activeNavbarSlice.reducer;